/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
/* eslint eqeqeq: "off" */
import { Snackbar } from "@material-ui/core";
import axios from "axios";
import React, { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../_metronic/layout";
import { CourseListSelection } from "../../SelectionWidgets/CourseListSelection";
import { InstructorListSelection } from "../../SelectionWidgets/InstructorListSelection";
import { SnackbarWrapper } from "../../Snackbar/SnackbarWrapper";
import { ProgramEditForm } from "./Components/ProgramEditForm";
import { toFlag, webRegisterPriceWarnings } from "./utils/webRegister";

// Blank -> null (inherit the branch default), otherwise a number. Never coerce
// blank to 0: that would store a $0 override.
const toCustomFee = (v) => {
  if (v === "" || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
const withCustomFee = (list) =>
  list.map((c) => ({ ...c, custom_fee: toCustomFee(c.custom_fee) }));

// School default = the branch_course_fee row with batch_type 7 (School
// Program). Fallback only, for course rows that arrive without default_fee.
const SCHOOL_PROGRAM_BATCH_TYPE = 7;
const fetchSchoolDefaultFee = async (courseId, branchId) => {
  const res = await axios(
    `api/programs/course-detail/${courseId}?branchId=${branchId}&show_all=true`
  );
  const fee = (res.data?.fees || []).find(
    (f) => f.batch_type == SCHOOL_PROGRAM_BATCH_TYPE
  );
  return fee ? fee.course_fee : null;
};

const initSchoolProgram = {
  day: "Monday",
  startdate: "",
  enddate: "",
  start_time: "",
  end_time: "",
  maximum_student: "",
  branch_id: "",
  active_id: "1",
  class_full_ind: "0",
  web_register_ind: "0", // off by default: the website lists it contact-only
  sessions: "",
  school_type_id: "7", //id of school program in batch_type table
  delivery_type_id: "1",
  program_type_id: "1",
  school_information_id: "",
};

export function ProgramEdit({
  history,
  match: {
    params: { id, duplicate, dest_id },
  },
}) {
  // Subheader
  const suhbeader = useSubheader();

  //school program data
  const [data, setData] = useState();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [editSuccessOpen, setEditSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [editErrorOpen, setEditErrorOpen] = useState(false);
  const [programCourses, setProgramCourses] = useState([]);
  const [programMissingCourses, setProgramMissingCourses] = useState([]);
  const [coursesToRemove, setCoursesToRemove] = useState([]);
  const [programInstructors, setProgramInstructors] = useState([]);
  const [programMissingInstructors, setProgramMissingInstructors] = useState([]);
  const [coursesToAdd, setCoursesToAdd] = useState([]);
  const [coachesToRemove, setCoachesToRemove] = useState([]);
  const [coachesToAdd, setCoachesToAdd] = useState([]);
  // "Register on website" is on but a course has no price (blank custom fee
  // and no branch default), so the website will show call-to-enroll for it.
  // Warns; the admin can still save.
  const [feeWarnOpen, setFeeWarnOpen] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);
  const [blankCourses, setBlankCourses] = useState([]);
  const btnRef = useRef();
  //getbranch
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  initSchoolProgram.branch_id = branch.branch_id;

  useEffect(() => {
    //TODO: fetch details for editing school program here
    const getSchoolProgramInfo = async () => {
      const program_info_url = `api/school-programs/${id}`;
      const res = await axios(program_info_url);
      const programData = res.data.results[0];
      // An older server doesn't return web_register_ind; show it as off.
      setData({ web_register_ind: 0, ...programData });
    };
    if (id) {
      getSchoolProgramInfo();
    }
  }, [id]);

  useEffect(() => {
    let _title = id ? "" : "New School Program";
    if (id && duplicate) {
      _title = `Duplicate School Program ${dest_id ? `- ${dest_id}` : ""}`;
    } else if (id) {
      _title = `Edit School Program - ${id}`;
    }

    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dest_id]);

  //Get List of courses not in school program
  useEffect(() => {
    const getMissingCourses = async () => {
      try {
        const courses_url = `api/school-programs/courses/missing/${id}/${branch.branch_id}`;
        const res = await axios(courses_url);
        setProgramMissingCourses(res.data.results);
      } catch (e) {
        console.log(e);
      }
    };
    id && getMissingCourses();
  }, [id]);

  //Get list of courses in School Program
  useEffect(() => {
    const getCourses = async () => {
      try {
        const courses_url = `api/school-programs/courses/${id}`;
        const res = await axios(courses_url);
        setProgramCourses(res.data.results);

        if (dest_id) {
          setCoursesToAdd(
            res.data.results.map((c) => {
              return {
                id: c.course_id,
                show_ind: c.show_ind,
                custom_fee: c.custom_fee ?? "",
                custom_course_description: c.custom_course_description || "",
              };
            })
          );
        }
      } catch (e) {
        console.log(e);
      }
    };
    id && getCourses();
  }, [id, dest_id]); 

  // The courses and missing-courses endpoints both return default_fee (null =
  // no default at this branch). Only look it up when a row lacks the field
  // entirely (an older server), once per course.
  const defaultFeeRequested = useRef(new Set());
  useEffect(() => {
    programCourses
      .filter(
        (c) =>
          c.default_fee === undefined &&
          !defaultFeeRequested.current.has(c.course_id)
      )
      .forEach(async (c) => {
        defaultFeeRequested.current.add(c.course_id);
        let defaultFee;
        try {
          defaultFee = await fetchSchoolDefaultFee(
            c.course_id,
            branch.branch_id
          );
        } catch (e) {
          console.log(e);
          defaultFeeRequested.current.delete(c.course_id);
          return;
        }
        setProgramCourses((prev) =>
          prev.map((pc) =>
            pc.course_id === c.course_id
              ? { ...pc, default_fee: defaultFee }
              : pc
          )
        );
      });
  }, [programCourses, branch.branch_id]);

  //Get List of instructors not in school program
  useEffect(() => {
    const getMissingInstructors = async () => {
      try {
        const instructors_url = `api/school-programs/instructors/missing/${id}`;
        const res = await axios(instructors_url);
        setProgramMissingInstructors(res.data.results);
      } catch (e) {
        console.log(e);
      }
    };
    id && getMissingInstructors();
  }, [id]);

  //Get list of instructors in School Program
  useEffect(() => {
    const getInstructors = async () => {
      try {
        const instructors_url = `api/school-programs/instructors/${id}`;
        const res = await axios(instructors_url);
        setProgramInstructors(res.data.results);

        if (dest_id) {
          setCoachesToAdd(
            res.data.results.map((c) => {
              return c.instructor_id;
            })
          );
        }
      } catch (e) {
        console.log(e);
      }
    };
    id && getInstructors();
  }, [id, dest_id]);

  const saveSchoolProgram = async (values) => {
    const formValues = values ? values : data;
  

    // Convert yes/no fields to 0/1. The form's Select hands back "0"/"1"
    // strings, so a strict === 1 check saved "Full" as 0.
    formValues.class_full_ind = toFlag(formValues.class_full_ind);
    formValues.web_register_ind = toFlag(formValues.web_register_ind);

    if (!id) {
      const schoolProgramsUrl = "api/school-programs";
      const result = await axios.post(schoolProgramsUrl, formValues);
      if (result.data != "failed") {
        setSuccessOpen(true);
        setTimeout(() => {
          history.push(`/school-programs/${result.data}/edit-program`);
        }, 1000);
      } else {
        setErrorOpen(true);
      }
    } else if (id && duplicate && !dest_id) {
      const schoolProgramsUrl = "api/school-programs/duplicate";
      const result = await axios.post(schoolProgramsUrl, formValues);
      if (result.data != "failed") {
        setSuccessOpen(true);
        setTimeout(() => {
          history.push(`/school-programs/${result.data}/edit-program`);
        }, 1000);
      } else {
        setErrorOpen(true);
      }
    } else {
      // Warn (don't block) when the program is registrable on the website
      // but a course has neither a custom fee nor a branch default: the site
      // will show call-to-enroll for it. Flag off = no warning.
      const blanks = webRegisterPriceWarnings(
        formValues.web_register_ind,
        programCourses
      );
      if (blanks.length) {
        setBlankCourses(blanks.map((c) => `${c.course_name} (${c.course_code})`));
        setPendingValues(formValues);
        setFeeWarnOpen(true);
        return;
      }
      await submitProgramEdit(formValues, coursesToAdd, programCourses);
    }
  };

  // Build payload + PATCH for the edit flow. custom_fee goes out as a number,
  // or null for blank (inherit the branch default).
  const submitProgramEdit = async (formValues, addCourses, editCourses) => {
    const send_data = {
      remove_courses: coursesToRemove,
      add_courses: withCustomFee(addCourses),
      edit_courses: withCustomFee(editCourses),
      remove_inst: coachesToRemove,
      add_inst: coachesToAdd,
      values: formValues, // Current form data included
    };

    const editSchoolProgramUrl = `api/school-programs/`;
    const result = await axios.patch(editSchoolProgramUrl, send_data);
    if (result.data != "failed") {
      setEditSuccessOpen(true);
      setTimeout(() => {
        history.push("/school-programs");
      }, 1000);
    } else {
      setEditErrorOpen(true);
    }
  };

  // Admin acknowledged the no-price warning: save as-is (blank stays null).
  const confirmNoFeeSave = async () => {
    setFeeWarnOpen(false);
    const formValues = pendingValues;
    setPendingValues(null);
    await submitProgramEdit(formValues, coursesToAdd, programCourses);
  };

  const updateCourseCustomField = useCallback((courseId, field, value) => {
    setProgramCourses((prev) =>
      prev.map((course) =>
        course.course_id === courseId ? { ...course, [field]: value } : course
      )
    );

    setCoursesToAdd((prev) =>
      prev.map((course) =>
        course.id === courseId ? { ...course, [field]: value } : course
      )
    );
  }, []);

  const handleClose = () => {
    setSuccessOpen(false);
    setErrorOpen(false);
    setEditErrorOpen(false)
    setEditSuccessOpen(false)
  };

  const saveSchoolProgramClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    } else {
      saveSchoolProgram(null);
    }
  };

  const backToSchoolProgramList = () => {
    history.push(`/school-programs`);
  };

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={
          successOpen
            ? successOpen
            : editSuccessOpen
            ? editSuccessOpen
            : errorOpen
            ? errorOpen
            : editErrorOpen
        }
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successOpen || editSuccessOpen ? "success" : "error"}
          message={
            successOpen
              ? "Added the school program successfully"
              : editSuccessOpen
              ? "Edited the school program successfully"
              : "Something went wrong"
          }
        />
      </Snackbar>
      <Modal show={feeWarnOpen} onHide={() => setFeeWarnOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>No Price for Website</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>
            Register on website is on, but the following course(s) have no
            price at this branch (no default fee and no custom fee on this
            program):
          </span>
          <ul className="mt-3 mb-3">
            {blankCourses.map((label, i) => (
              <li key={i}>{label}</li>
            ))}
          </ul>
          <span>
            The website will show call-to-enroll for them until a fee is set.
            Add a School Program default under Branch Courses &gt; Course
            Fees, or enter a custom fee here. Save anyway?
          </span>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={() => setFeeWarnOpen(false)}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={confirmNoFeeSave}
            className="btn btn-primary btn-elevate"
          >
            Save Anyway
          </button>
        </Modal.Footer>
      </Modal>
      <Card>
        <CardHeader title={title}>
          <CardHeaderToolbar>
            <button
              type="button"
              onClick={backToSchoolProgramList}
              className="btn btn-light"
            >
              <i className="fa fa-arrow-left"></i>
              Back
            </button>
            {`  `}
            <button
              type="submit"
              className="btn btn-primary ml-2"
              onClick={saveSchoolProgramClick}
            >
              Save
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ul className="nav nav-tabs nav-tabs-line " role="tablist">
            <li className="nav-item" onClick={() => setTab("basic")}>
              <a
                className={`nav-link ${tab === "basic" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "basic").toString()}
              >
                Basic info
              </a>
            </li>
            {((id && !duplicate) || (id && duplicate && dest_id)) && (
              <>
                <li className="nav-item" onClick={() => setTab("coaches")}>
                  <a
                    className={`nav-link ${tab === "coaches" && "active"}`}
                    data-toggle="tab"
                    role="button"
                    aria-selected={(tab === "coaches").toString()}
                  >
                    Coaches
                  </a>
                </li>
                <li className="nav-item" onClick={() => setTab("courses")}>
                  <a
                    className={`nav-link ${tab === "courses" && "active"}`}
                    data-toggle="tab"
                    role="tab"
                    aria-selected={(tab === "courses").toString()}
                  >
                    Streams
                  </a>
                </li>
              </>
            )}
          </ul>
          <div className="mt-5">
            {tab === "basic" && (
              <ProgramEditForm
                schoolProgram={data ? data : initSchoolProgram}
                btnRef={btnRef}
                saveSchoolProgram={saveSchoolProgram}
              />
            )}
            {tab === "courses" && id && (
              <div>
                <CourseListSelection
                  id={id}
                  type={"camp"}
                  setCoursesToAdd={setCoursesToAdd}
                  coursesToAdd={coursesToAdd}
                  setCoursesToRemove={setCoursesToRemove}
                  coursesToRemove={coursesToRemove}
                  campCourses={programCourses}
                  setCampCourses={setProgramCourses}
                  campMissingCourses={programMissingCourses}
                  setCampMissingCourses={setProgramMissingCourses}
                  allowCustomFields={true}
                  onUpdateCustomField={updateCourseCustomField}
                />
              </div>
            )}
            {tab === "coaches" && id && (
              <div>
                <InstructorListSelection
                  id={id}
                  type={"camp"}
                  setCoachesToAdd={setCoachesToAdd}
                  coachesToAdd={coachesToAdd}
                  coachesToRemove={coachesToRemove}
                  setCoachesToRemove={setCoachesToRemove}
                  campInstructors={programInstructors}
                  setCampInstructors={setProgramInstructors}
                  campMissingInstructors={programMissingInstructors}
                  setCampMissingInstructors={setProgramMissingInstructors}
                />
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}
